import BaseService from "../BaseService";
import _ from "lodash";

class ProfileService extends BaseService {

    get = async (code) => {
        var data = await this._api.get(`/store/profile`);
        return data;
    };

    requestBankChange = async (info) => {
        var data = await this._api.post(`/store/profile/requestbankchange`, info);
        return data;
    }

    updateInfo = async (info) => {
        var data = await this._api.post(`/store/profile/update_info`, info);
        return data;
    }


    saveBankWithOTP = async (info) => {
        var data = await this._api.post(`/store/profile/savebankwithotp`, info);
        return data;
    }







}
export default ProfileService;
